import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
import { ReactComponent as ForkIcon5 } from "../../assets/icons/Fork5.svg";

const UserJourney = () => {
  const items = [
    {
      title: "Broken Install Process",
      description:
        "Redirects often result in abandoned installs. With Dynamic Links, users are taken directly to the app store and the exact content they’re looking for.",
    },

    {
      title: "Frustrating Journeys",
      description:
        "No more generic landing pages. Dynamic Links take users straight to the relevant content, saving time and improving satisfaction.",
    },

    {
      title: "Untrackable Referrals",
      description:
        "Standard links don’t offer tracking. Dynamic Links are personalized, trackable, and provide insights on every referral, so you can measure success.",
    },

    {
      title: "Inconsistent Experiences",
      description:
        "Deliver a seamless, cross-device & cross-platform experience that keeps users engaged, no matter where they are.",
    },
    {
      title: "Impersonal Onboarding",
      description:
        "Pre-fill user details for faster, personalized onboarding, making the journey smoother from the start.",
    },
  ];
  return (
    <FullPageContainer>
      <Container id={"userJourney"}>
        <Content>
          <TextWrapper>
            <Title>Remove Friction from the User Journey</Title>
            <Subtitle>
              Users expect a smooth experience. Broken links, redirects, and
              complicated installs create barriers that lead to frustration and
              lost engagement. Dynamic Links remove these obstacles, guiding
              users effortlessly to your content—on any device, every time.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon5 color="rgba(11, 39, 44, 0.55)" />
            </ForkWrapper>
            <ItemsWrapper>
              {items.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default UserJourney;
const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
padding:100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 30px;
  max-width: 850px;
  @media (max-width: 990px) {
    max-width: unset;
  }
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 24px;
    text-align: center;
  }
`;
const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;

`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
display:flex;
align-items:center;
height:100%;
  @media (max-width: 990px) {
    display: none;
  }
`;
